"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var STORE_KEY = 'redux-storage';
var storageItem = localStorage.getItem(STORE_KEY);
var store = storageItem ? JSON.parse(storageItem) : {};
var storage = function (reducer, name) {
    if (name === void 0) { name = 'reducer'; }
    return function (state, action) {
        var _a;
        var next = reducer(state || store[name], action);
        store = __assign(__assign({}, store), (_a = {}, _a[name] = next, _a));
        localStorage.setItem(STORE_KEY, JSON.stringify(store));
        return next;
    };
};
exports.default = storage;
